import { client } from './generated/client.gen';

export * from './services';
export * from './api.context';

// App-level pluggable getter for Auth0 access tokens
let tokenGetter: (() => Promise<string | undefined>) | undefined;

/**
 * Call this once when your app initializes (after Auth0 is ready),
 * e.g. registerAuth0Getter(() => getAccessTokenSilently());
 */
export function registerAuth0Getter(fn: () => Promise<string | undefined>) {
    tokenGetter = fn;
}

client.setConfig({
    baseURL: import.meta.env.VITE_API_SERVER_URL as string,
    security: [
        {
            scheme: 'bearer',
        },
    ],
    auth: async () => {
        return tokenGetter ? tokenGetter() : undefined;
    },
});
